<template>
  <div>
    <div
      class="mb-5 flex items-center space-x-3 text-body-5-d font-medium text-white"
    >
      <span>
        {{ currentCurrency?.country_code == "US" ? "Diagu Inc" : "Diagu Ltd" }}
      </span>
      <SelectCurrency />
    </div>
    <div
      v-if="currentCurrency?.country_code == 'US'"
      class="space-y-2.5 text-sm font-light text-white"
    >
      <div>10803 Thornmint Rd #200</div>
      <div>San Diego, CA 92127, United States</div>
      <div
        class="flex flex-col space-y-2.5 md:flex-row md:space-x-4 md:space-y-0"
      >
        <div>DUNS: 119065029</div>
      </div>
    </div>
    <div v-else class="space-y-2.5 text-sm font-light text-white">
      <div>10 Harley Street,</div>
      <div>London W1G 9PF,</div>
      <div>United Kingdom</div>
      <div
        class="flex flex-col space-y-2.5 md:flex-row md:space-x-4 md:space-y-0"
      >
        <div>DUNS: 230105739</div>
        <div>VAT: GB444891171</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectCurrency from "@/components/Core/SelectCurrency.vue";
export default {
  name: "FooterAddress",
  computed: {
    ...mapGetters({
      currentCurrency: "currency/getCurrentCurrency",
    }),
  },
  components: { SelectCurrency },
};
</script>
